/* eslint-disable jsx-a11y/label-has-associated-control */
import DateFnsUtils from '@date-io/date-fns';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import { useSelector } from 'react-redux';

const useStyle = makeStyles({
  middleItem: {
    height: '65vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  certInfo: {
    width: '98%',
    height: '50px',
    display: 'flex',
    gap: '60px',
    padding: '15px 0px',
    borderBottom: '1px solid #D0D5DD',
  },
  heading: {
    color: '#667085',
  },
  item: {
    color: '#10182B',
    marginTop: '5px',
  },
  dateWrapper: {
    marginTop: '15px',
    width: '98%',
  },
  dateBox: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '15px',
  },

  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    marginTop: '9px',
    marginBottom: '9px',
  },
  placeholderColor: {
    '&::placeholder': {
      color: '#98A2B3',
    },
  },
});
export function AssignDates({ endDate, setEndDate }) {
  const classes = useStyle();

  const selectedCertInfo = useSelector((state) => state.certificateData.selectedCertInfo);

  // Get today's date
  const today = new Date();

  return (
    <Grid className={classes.middleItem}>
      <Grid className={classes.certInfo}>
        <Grid className={classes.cert}>
          <Typography className={classes.heading}>Certification:</Typography>
          <Typography className={classes.item}>
            {selectedCertInfo?.name} <span style={{ color: '#667085 ' }}>(Id: {selectedCertInfo?.id})</span>
          </Typography>
        </Grid>
        <Grid className={classes.duration}>
          <Typography className={classes.heading}>Duration:</Typography>
          <Typography className={classes.item}>{selectedCertInfo?.duration} Days </Typography>
        </Grid>
      </Grid>
      <Grid className={classes.dateWrapper}>
        <Grid className={classes.dateBox}>
          <Grid item style={{ width: '45%' }}>
            <div className={classes.popupLabels}>
              <label htmlFor="courseOverview" className={classes.required_field}>
                End Date
              </label>
            </div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                placeholder="YYYY-MM-DD"
                value={endDate}
                onChange={setEndDate}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    input: 'date-field',
                  },
                }}
                format="yyyy-MM-dd"
                style={{
                  width: '95%',
                  backgroundColor: 'white',
                  height: '40px',
                  borderRadius: 8,
                  padding: '10px',
                }}
                minDate={today}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
